
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.156 8.094v3.281H4.852V8.094C2.159 7.979.812 6.823.812 4.625c0-1.635.915-3.055 2.743-4.258l.46.547c-1.14.88-1.71 2.057-1.71 3.531 0 1.865.849 2.867 2.547 3.008v-3.39c0-1.13.247-2.024.742-2.68C6.089.727 6.789.398 7.695.398c.834 0 1.521.303 2.063.907.547.604.82 1.442.82 2.515 0 1.339-.375 2.375-1.125 3.11-.75.729-1.849 1.117-3.297 1.164zm0-.61c1.974-.109 2.961-1.34 2.961-3.695 0-.865-.14-1.536-.422-2.016-.276-.479-.65-.718-1.125-.718-.354 0-.65.133-.89.398-.24.26-.388.612-.446 1.055-.052.437-.078 1.138-.078 2.101v2.875z","fill":"currentColor"}})])
          )
        }
      }
    